<ng-container *ngIf="screenName != 'job-listing'">
  <app-jobs-candidates-slide-filter [valuesSentForFilters]="entitySent"
    (valuesRetainedForFilters)="onFilterToggle($event)">
    <app-candidate-vertical-filter-template *ngIf="panel == 'candidates'" [candidateFilterData]="filterConfig"
      [filterChanges]="filterChanges" [businessId]="businessId"></app-candidate-vertical-filter-template>
    <app-job-invites-filter *ngIf="panel == 'job invites' && showApplicantFilter==true"></app-job-invites-filter>
    <app-jobs-applied-filter *ngIf="panel == 'jobs applied' && showApplicantFilter==true"></app-jobs-applied-filter>
  </app-jobs-candidates-slide-filter>

  <header>

    <div class="hpanel" data-gs-cards="native">
      <div class="panel-body filter-hdr-pad shdwcon brad-0">
        <div class="job-candidate-container pad-lt-0">
          <div class="row">
            <div class="dropdown-filters-container mr-rt-lt-0 form-group">
              <div class="gs-search-box gs-search-box--filter mr-lt-16">
                <span class="cand-search-svg-icon">
                  <ng-icon name="tablerSearch"></ng-icon>
                </span>
                <input #Search placeholder="Search Candidates, Candidates Title, Candidate ID, Tags"
                  [(ngModel)]="searchContent" [ngModelOptions]="{standalone: true}" (input)="searchfilter(Search.value)"
                  type="text" class="input-sm form-control job-cand-searchBox" />
              </div>
              <div class="job-cand-dropdown-filter-elements-container">
                <app-candidate-filter-template [businessId]="businessId" [candidateFilterData]="filterConfig"
                  [filterChanges]="tempFilterChanges" (valuesRetainedForFilters)="onFilterToggle($event)"
                  [loading]="loadSkeleton | async" (panelValue)="getPanelValue($event)"></app-candidate-filter-template>
              </div>
              <div class="all-filter-container">
                <div class="all-filters" (click)="openFilterSlider()">
                  <span>
                    All Filters
                  </span>
                  <ng-icon name="tablerFilter"></ng-icon>
                </div>
                <div class="reset-filters" (click)="resetFilternew()">
                  <span>
                    Reset
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- <div class="form-group">
          <input placeholder="Search Candidates, Candidates Title, Candidate ID, Tags" [(ngModel)]="searchContent"
              [ngModelOptions]="{standalone: true}" (input)="searchfilter()" type="text"
              class="input-sm form-control" />
          <i class="fa-solid fa-magnifying-glass"></i>
          </div> -->
    <!-- <div class="row">
      <div class="col-sm-12">
        <div class="filters" style="cursor: pointer;">
          <div class="filters-list" (click)="removeEntitynew(candi,i)"
            *ngFor="let candi of candidateSource; let i=index;">
            <span class="filter-list-item" *ngIf="candi=='featured' && !FeaSugg">
              <span>
                <i [ngClass]="uniqueColorClasses[i]"></i>
              </span> Featured Candidates
            </span>
            <span class="filter-list-item" *ngIf="candi=='benchNetworkCandidates'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span> Bench Sales
              Network</span>
            <span class="filter-list-item" *ngIf="candi=='AWAITING HOST'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span> Awaiting Post</span>
            <span class="filter-list-item" *ngIf="candi=='freeLancerNetworkCandidates'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span>
              Freelancer Network</span>
            <span class="filter-list-item" *ngIf="candi=='mtaNetworkCandidates'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span> MTA
              Network</span>
            <span class="filter-list-item" *ngIf="candi=='jobSeekerNetworkCandidates'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span>Job
              Seeker Network</span>
            <span class="filter-list-item" *ngIf="candi=='myCandidates' && userType!='JOB_SEEKER'&&userType!='student'">
              <span><i [ngClass]="uniqueColorClasses[i]"></i></span> My Candidates</span>
            <span class="filter-list-item" *ngIf="candi=='myCandidates' && userType=='JOB_SEEKER'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span> My Profiles</span>
            <span class="filter-list-item" *ngIf="candi=='teamCandidates'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span> Pro
              Candidates</span>
            <span class="filter-list-item" *ngIf="candi=='suggestedCandidates' && !FeaSugg"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span>
              Marketplace Candidates</span>
            <span class="filter-list-item" *ngIf="candi=='remoteWork'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span>
              Remote Work</span>
            <span class="filter-list-item" *ngIf="candi=='relocationRequired'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span> Relocation
              Required</span>
            <span class="filter-list-item" *ngIf="candi=='workFromHome'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span> Work From Home</span>
            <span class="filter-list-item" *ngIf="candi=='allPlatFormCandidates'"> <span><i
                  [ngClass]="uniqueColorClasses[i]"></i></span> Candidates From Platform</span>
            <span class="filter-list-item" *ngIf="candi!='featured'&& candi!='AWAITING HOST'&& candi!='jobSeekerNetworkCandidates'
                              && candi!='benchNetworkCandidates'&& candi!='myCandidates' && candi!='teamCandidates'
                              && candi!='suggestedCandidates'&& candi!='remoteWork' && candi!='relocationRequired'
                              && candi!='workFromHome' && candi!='freeLancerNetworkCandidates'&& candi!='mtaNetworkCandidates'
                               && candi!='featured' && candi != 'allPlatFormCandidates'"
              style="text-transform: capitalize;">
              <span><i [ngClass]="uniqueColorClasses[i]"></i></span>
              {{candi}}</span>
            <span class="filter-tag-close-icon-style">
              <svg width="15" height="15" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M18 6L6 18M6 6l12 12" stroke="#000" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div> -->

  </header>

  <div id="job-listing-content" class="job-listing-content">
    <div id="entity-container" class="job-candidate-container" [class.pointer-events-none]="isFilterOpen">
      <div class="job-candidate-listing-flex-container">
        <div class="entity-listing">
          <!-- V3 left panel header -->
          <div class="jc-v3-lp-header" *ngIf="designVersion === 'v3'">
            <div class="jc-v3-lp-title">
              <div class="jc-v3-lp-icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="8" r="5"/><path d="M3 21v-2a7 7 0 0 1 14 0v2"/></svg>
              </div>
              Candidates <span class="jc-v3-lp-count">{{totalCandidatesCount}} results found</span>
            </div>
          </div>
          <!-- V2 left panel header (existing) -->
          <div class="entity-listing-header" *ngIf="designVersion !== 'v3'">
            <div class="entity-summary pad-rt-0">
              <ng-icon name="tablerUsers" class="svg-position"></ng-icon>
              <div class="entity-name">
                <h6>
                  <span *ngIf="userType!='JOB_SEEKER'">{{ candidateListLabel }}</span>
                </h6>
                <h6>
                  <span *ngIf="userType === 'JOB_SEEKER'">
                    {{ jobSeekerListName }}<span *ngIf="totalCandidatesCount > 1">s</span>
                  </span>
                </h6>
              </div>
              <div class="entitycount">
                <span id="totalCandidateCount">{{totalCandidatesCount}} results found</span>
              </div>
            </div>
          </div>

          <!-- NEW SIMPLIFIED SEARCH AND FILTER SECTION -->
          <!-- <div class="search-filter-container-8472">
            <div class="search-input-wrapper-9384">
              <div class="search-icon-container-2847">
                <ng-icon name="tablerSearch"></ng-icon>
              </div>
              <input #SearchNew placeholder="Search Candidates, Title, ID, Tags" type="text" [(ngModel)]="searchContent"
                [ngModelOptions]="{standalone: true}" (input)="searchfilter(SearchNew.value)"
                class="search-input-field-5729" />
            </div>
            <div class="filter-actions-container-6192" [ngClass]="{'disabled' : loadCenterSkeleton | async }">
              <div class="filter-icon-btn-3856" (click)="openFilterSlider()">
                <div class="filter-icon-wrapper-4721">
                  <svg class="filter-icon-svg-8934" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 7H20M7 12H17M10 17H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  <span class="filter-count-badge-2853" *ngIf="getActiveFilterCount() > 0">
                    {{getActiveFilterCount()}}
                  </span>
                </div>
              </div>
              <div class="reset-btn-1473" (click)="resetFilternew()">
                Reset
              </div>
            </div>
          </div> -->

          <div id="candidate-body" class="entity-listing-body" infiniteScroll [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="200" (scrolled)="onScrollDown()" [scrollWindow]="false" [alwaysCallback]="true">

            <ng-container *ngIf="(loadCenterSkeleton | async)">
              <app-common-skeleton [countforView]="4" [NameOftheScreen]="'jobcardMediumscreen'"></app-common-skeleton>
            </ng-container>

            <app-candidates-page #candidatesRef [Obj]="selectedCandidateData" [loadAPIcall]="(loadSkeleton | async)"
              [updateCandidateModule]="candidateModule" [dataPasstoSkillwidgets]="dataPasstoSkillwidgets"
              [viewSize]="designVersion === 'v3' ? 'jc-v3-small' : 'small'" (updateStatusAndFilters)="onStatusChangeEvent($event)"
              (candidateFilterFromComponent)="onStatusChangeEvent($event)"
              [candidatesFoundStatus]="(loadSkeleton | async)? '' : candidateFoundStatus"
              [passValues]="(response | async)" [jobData]="jobDataToBeSent"
              (candidateReloadFromComponent)="reloadFilter($event)" (candidateListing)="onStatuChange($event)"
              [removeSelected]="removeSelected" [removeTag]="removeTagvalues" (candidateReload)="reloadFilter($event)"
              (suggjob)="getsuggjob($event)" (selectedCandidate)="getchildData($event)"
              [responseReceived]="apiCompleted"></app-candidates-page>



            <div *ngIf="designVersion === 'v3' && stopscrollFlag && (response | async)?.length > 0" class="jc-v3-list-done">
              <ng-icon name="tablerCircleCheck"></ng-icon>
              <p>You've reached the bottom of the page</p>
            </div>
            <div *ngIf="designVersion !== 'v3' && stopscrollFlag && (response | async)?.length > 0" class="row caught_up">
              <!-- <ng-icon name="tablerCircleCheck"></ng-icon>        -->
              <ng-icon name="tablerCircleCheck"></ng-icon>

              <div class="col-md-12">
                <p class="biase">You've reached the bottom of the page</p>
              </div>
            </div>
          </div>
        </div>
        <div class="entity-details" [class.jc-v3-entity-details]="designVersion === 'v3'">
          <app-common-skeleton *ngIf="(loadCenterSkeleton | async)"
            [NameOftheScreen]="'jobselectedscreen'"></app-common-skeleton>

          <ng-container *ngIf="!(loadCenterSkeleton | async) && (response | async)?.length > 0; else emptyMessage">

            <!-- V3 persistent candidate detail header -->
            <div class="jc-v3-detail-header" *ngIf="designVersion === 'v3' && selectedCandidateData?.candidateId">
              <!-- Section 1: Candidate avatar + name | Connection -->
              <div class="jc-v3-dh-s1">
                <div style="display:flex;flex-direction:column;gap:12px;">
                  <!-- Hidden entirely when the candidate has no organization
                       (e.g. FR users post without postedBehalfOf) — otherwise
                       an empty briefcase icon + star rendered alone. -->
                  <div class="jc-v3-dh-company" *ngIf="selectedCandidateData?.postedBehalfOf">
                    <div class="jc-v3-co-logo">
                      <img *ngIf="getCandidateBusinessLogo() as logo"
                        [src]="logo" alt="Logo"
                        style="width:100%;height:100%;object-fit:cover;border-radius:10px;">
                      <svg *ngIf="!getCandidateBusinessLogo()" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563EB" stroke-width="2">
                        <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
                      </svg>
                    </div>
                    <div>
                      <div class="jc-v3-co-name">
                        {{ selectedCandidateData?.postedBehalfOf }}
                        <ng-icon name="tablerStar" class="jc-v3-star" aria-hidden="true"></ng-icon>
                      </div>
                    </div>
                  </div>
                  <!-- Candidate Profile Section -->
                  <div class="jc-v3-dh-company">
                  <div class="jc-v3-co-logo"
                    [style.background]="(!selectedCandidateData?.photo || selectedCandidateData?.photo === 'null' || selectedCandidateData?.photo === '') ? getCandidateAvatarColor() : null">
                    <img *ngIf="selectedCandidateData?.photo && selectedCandidateData?.photo !== 'null' && selectedCandidateData?.photo !== ''"
                      [src]="selectedCandidateData?.photo?.startsWith('http') ? selectedCandidateData?.photo : url + selectedCandidateData?.photo"
                      alt="Avatar" style="width:100%;height:100%;object-fit:cover;border-radius:10px;"
                      (error)="$event.target.style.display='none'">
                    <span *ngIf="!selectedCandidateData?.photo || selectedCandidateData?.photo === 'null' || selectedCandidateData?.photo === ''"
                      style="font-size:13px;font-weight:700;"
                      [style.color]="getCandidateAvatarTextColor()">
                      {{ getCandidateInitials() }}
                    </span>
                  </div>
                  <div>
                    <div class="jc-v3-co-name">
                      {{ selectedCandidateData?.firstName || selectedCandidateData?.user?.firstName }}
                      {{ selectedCandidateData?.lastName || selectedCandidateData?.user?.lastName }}
                    </div>
                  </div>
                </div>
                </div>
                <!-- Candidate Owner (the recruiter / bench-sales user who
                     created this candidate). Mirrors the V2
                     `candidate-profile-summary` + connection-template
                     `candidate-profile-1` page (lines 113-218 of
                     connection-template.component.html): photo → fullname →
                     userType → org-from-workExperience-with-star → city/state.
                     The Connect / Chat buttons come from the V3
                     `jc-v3-candidate-profile` block of connection-template. -->
                <div class="jc-v3-dh-recruiter" *ngIf="selectedCandidateData?.user">
                  <!-- Owner avatar — photo if available, hashed-pastel
                       initials otherwise (parity with the V2 connection
                       template at lines 117-123). -->
                  <img *ngIf="selectedCandidateData?.user?.photo"
                    class="jc-v3-rec-av"
                    [src]="selectedCandidateData?.user?.photo?.startsWith('http') ? selectedCandidateData?.user?.photo : url + selectedCandidateData?.user?.photo"
                    alt="Owner avatar"
                    (error)="$any($event.target).style.display='none'">
                  <div *ngIf="!selectedCandidateData?.user?.photo"
                    class="jc-v3-rec-av"
                    [style.background-color]="getOwnerAvatarColor()"
                    [style.color]="getOwnerAvatarTextColor()">
                    {{ getOwnerInitials() }}
                  </div>

                  <div class="jc-v3-rec-info">
                    <strong [title]="selectedCandidateData?.user?.fullname || selectedCandidateData?.createdByUserName">{{ selectedCandidateData?.user?.fullname || selectedCandidateData?.createdByUserName }}</strong>
                    <span>
                      {{ formatCandidateUserType(selectedCandidateData?.user?.userType || selectedCandidateData?.createdByUserType) }}
                    </span>
                    <!-- Org row — non-freelance owners show their
                         current-organization entry; freelance recruiters
                         show the workExperience entry that matches
                         `postedBehalfOf` (V2 parity at lines 144-177). -->
                    <ng-container *ngIf="selectedCandidateData?.user?.userType !== 'FREELANCE_RECRUITER'">
                      <ng-container *ngFor="let work of selectedCandidateData?.user?.workExperience">
                        <span *ngIf="work?.currentOrganization" [title]="work?.organisationName">
                          &middot; {{ work?.organisationName }}
                        </span>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="selectedCandidateData?.user?.userType === 'FREELANCE_RECRUITER'">
                      <ng-container *ngFor="let work of selectedCandidateData?.user?.workExperience">
                        <span *ngIf="selectedCandidateData?.postedBehalfOf === work?.organisationName"
                              [title]="work?.organisationName">
                          &middot; {{ work?.organisationName }}
                        </span>
                      </ng-container>
                    </ng-container>
                    <!-- Fallback when workExperience is empty but
                         `postedBehalfOf` has a value -->
                    <ng-container *ngIf="!selectedCandidateData?.user?.workExperience?.length && selectedCandidateData?.postedBehalfOf">
                      <span [title]="selectedCandidateData?.postedBehalfOf">
                        &middot; {{ selectedCandidateData?.postedBehalfOf }}
                      </span>
                    </ng-container>
                    <!-- Owner City/State -->
                    <ng-container *ngFor="let work of selectedCandidateData?.user?.workExperience">
                      <span *ngIf="work?.currentOrganization && (work?.city || work?.state)" style="display:block;font-size:11px;color:#6B7280;margin-top:2px;">
                        {{ work?.city }}<span *ngIf="work?.city && work?.state">, </span>{{ work?.state }}
                      </span>
                    </ng-container>
                  </div>

                  <app-connection-template
                    [page]="'jc-v3-candidate-profile'"
                    [connectionStatus]="selectedCandidateData?.connectionStatus"
                    [counterpartsDetails]="selectedCandidateData?.user"
                    [values]="selectedCandidateData"
                    [module]="'candidate'">
                  </app-connection-template>
                </div>
              </div>
              <!-- Section 2: Title + Status + Info + Tags -->
              <div class="jc-v3-dh-s2">
                <div class="jc-v3-dh-title-row">
                  <span class="jc-v3-dh-title">{{ selectedCandidateData?.jobTitle }}</span>
                  <!-- AUDIT_04 Batch 4 — "On Hold" pill now covers the
                       ACTIVE-but-unavailable state (V2 left card surfaced
                       this distinction; V3 header previously glossed over
                       it and showed "Active"). -->
                  <span class="jc-v3-pill jc-v3-pill-green" *ngIf="selectedCandidateData?.status === 'ACTIVE' && selectedCandidateData?.availability !== false">Available</span>
                  <span class="jc-v3-pill jc-v3-pill-amber" *ngIf="selectedCandidateData?.status === 'ON HOLD' || (selectedCandidateData?.status === 'ACTIVE' && selectedCandidateData?.availability === false)">On Hold</span>
                  <span class="jc-v3-pill jc-v3-pill-amber" *ngIf="selectedCandidateData?.status === 'DRAFT' || selectedCandidateData?.status === 'DRAFTED'">Draft</span>
                  <span class="jc-v3-pill jc-v3-pill-red" *ngIf="selectedCandidateData?.status === 'UNAVAILABLE' || selectedCandidateData?.status === 'INACTIVE'">Unavailable</span>
                  <!-- Blocked uses the exact left-card red (getStyle('BLOCKED') =
                       #d40000/#ffe5e5), matching the job detail header's Blocked
                       pill (new-job.component.html:229-232). -->
                  <!-- <span class="jc-v3-c-cand-status"
                        *ngIf="selectedCandidateData?.status === 'BLOCKED'"
                        [style.background-color]="'#ffe5e5'"
                        [style.color]="'#d40000'">Blocked</span> -->   
                  <span class="jc-v3-pill jc-v3-pill-red" *ngIf="selectedCandidateData?.status === 'BLOCKED'">Blocked</span>
                  <!-- "Hot" badge + countdown row — mirrors the V3 job
                       detail's urgent row (new-job.component.html:286-292)
                       so the upgraded-candidate banner renders with the
                       same red pill + "ends in X day(s)" line. Replaces
                       the legacy `urgent-hire-badge` markup that was
                       washing out on the V3 candidate detail page. -->
                  <div class="jc-v3-urgent-row" *ngIf="getActiveUrgencyDays(selectedCandidateData) as urgencyDays">
                    <span class="jc-v3-urgent-badge">
                      <ng-icon name="tablerFlame" style="font-size: 10px;"></ng-icon>
                      Hot
                    </span>
                  </div>
                  <!-- Action buttons — mirrors job detail header pattern.
                       AUDIT_04 CG10 — pointer-events-none while filter slider
                       is open so Invite/Edit/More cannot fire under the
                       backdrop (parity with #entity-container guard). -->
                  <div class="jc-v3-dh-toggle-row" [class.pointer-events-none]="isFilterOpen">
                    <button class="jc-v3-btn jc-v3-btn-primary jc-v3-btn-sm"
                      *ngIf="selectedCandidateData?.createdBy !== userIdStorage && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
                      [class.disabled]="!selectedCandidateData?.availability || selectedCandidateData?.status !== 'ACTIVE'"
                      (click)="inviteSelectedCandidate()">
                      Invite To Apply
                    </button>
                    <button class="jc-v3-btn jc-v3-btn-outline jc-v3-btn-sm"
                      *ngIf="selectedCandidateData?.createdBy === userIdStorage && selectedCandidateData?.status !== 'BLOCKED'"
                      (click)="editSelectedCandidate()">
                      Edit
                    </button>
                    <!-- Inline owner toggle — mirrors the job detail-header
                         pattern (new-job.component.html:242-253). Restores
                         the visible Active ↔ Unavailable switch that was
                         previously buried inside the "More" dropdown.
                         Delegates to enableSelectedCandidate which runs
                         the plan-check + PUT via profile-summary.enableCandidate(). -->
                    <label class="jc-v3-dh-toggle-label"
                      *ngIf="selectedCandidateData?.createdBy === userIdStorage && selectedCandidateData?.status !== 'BLOCKED' && selectedCandidateData?.status !== 'DRAFTED'"
                      [title]="selectedCandidateData?.status === 'ACTIVE' ? 'Mark unavailable' : 'Mark available'">
                      <input type="checkbox"
                        [checked]="selectedCandidateData?.status === 'ACTIVE'"
                        (click)="enableSelectedCandidate($event)">
                      <span class="jc-v3-toggle" [class.on]="selectedCandidateData?.status === 'ACTIVE'"></span>
                    </label>
                    <div class="jc-v3-dh-more-wrap" dropdown
                      *ngIf="selectedCandidateData?.createdBy === userIdStorage && selectedCandidateData?.status !== 'BLOCKED'"
                      [isOpen]="openDetailHeaderDropdown" (isOpenChange)="onDetailHeaderDropdownToggle($event)">
                      <button class="jc-v3-dh-more-btn" dropdownToggle>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="5" r="1.2"/><circle cx="12" cy="12" r="1.2"/><circle cx="12" cy="19" r="1.2"/></svg>
                        More
                      </button>
                      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right jc-v3-dh-more-dropdown" role="menu">
                        <li role="menuitem"
                          *ngIf="selectedCandidateData?.resumeAttached === false && selectedCandidateData?.status === 'ACTIVE'">
                          <a class="dropdown-item" (click)="uploadResumeForCandidate()">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:8px;"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>Upload Resume
                          </a>
                        </li>
                        <li role="menuitem">
                          <a class="dropdown-item" (click)="editSelectedCandidate()">
                            <ng-icon name="tablerEdit" style="margin-right:8px;"></ng-icon>Edit Candidate
                          </a>
                        </li>
                        <!-- Republish / Upgrade / Downgrade — parity with the
                             job detail-header More menu (new-job.component.html:272-278).
                             Gates mirror the job-side rules adapted for candidate states:
                             ACTIVE → can republish; non-INACTIVE/DRAFTED & not featured → can upgrade;
                             featured & non-INACTIVE/DRAFTED → can downgrade. -->
                        <li role="menuitem" *ngIf="selectedCandidateData?.status === 'ACTIVE'">
                          <a class="dropdown-item" (click)="republishSelectedCandidate()">
                            <ng-icon name="tablerRefresh" style="margin-right:8px;"></ng-icon>Republish
                          </a>
                        </li>
                        <li role="menuitem"
                          *ngIf="selectedCandidateData?.status !== 'INACTIVE' && selectedCandidateData?.status !== 'DRAFTED' && !selectedCandidateData?.isFeatured && userType !== 'JOB_SEEKER'">
                          <a class="dropdown-item" (click)="upgradeSelectedCandidate()">
                            <ng-icon name="tablerCircleArrowUp" style="margin-right:8px;"></ng-icon>Upgrade Candidate
                          </a>
                        </li>
                        <li role="menuitem"
                          *ngIf="selectedCandidateData?.isFeatured && selectedCandidateData?.status !== 'INACTIVE' && selectedCandidateData?.status !== 'DRAFTED'">
                          <a class="dropdown-item" (click)="downgradeSelectedCandidate()">
                            <ng-icon name="tablerCircleArrowDown" style="margin-right:8px;"></ng-icon>Downgrade Candidate
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="jc-v3-dh-info-row">
                  <div class="jc-v3-dh-info-item">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                    Created On {{ selectedCandidateData?.updatedOn | timezoneDate:'MM/dd/yyyy' }}
                  </div>
                  <div class="jc-v3-dh-info-item" *ngIf="selectedCandidateData?.candidateReferenceId">
                    Candidate ID <code>{{ selectedCandidateData?.candidateReferenceId }}</code>
                  </div>
                  <div class="jc-v3-dh-info-item" *ngIf="selectedCandidateData?.city || selectedCandidateData?.state || selectedCandidateData?.country">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                    {{ formatLocation(selectedCandidateData?.city, selectedCandidateData?.state, selectedCandidateData?.country) }}
                  </div>
                  <!-- Rate can come back blank/null from the API; a `!= undefined`
                       guard still lets "" through and renders a half-empty
                       "– USD /" chip, so fall back to "Not Available". -->
                  <div class="jc-v3-dh-info-item"
                    [title]="(selectedCandidateData?.targetRateFrom && selectedCandidateData?.targetRateTo)
                      ? ('Employee Estimate: ' + selectedCandidateData?.targetRateFrom + ' - ' + selectedCandidateData?.targetRateTo + ' ' + getCurrency(selectedCandidateData?.country) + ' / ' + getPayType(selectedCandidateData?.payType))
                      : 'Employee Estimate: Not available'">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                    <span class="jc-v3-dh-rate-label">Employee Estimate:</span>
                    <ng-container *ngIf="selectedCandidateData?.targetRateFrom && selectedCandidateData?.targetRateTo; else noRateDetailHeader">
                      {{ selectedCandidateData?.targetRateFrom }}–{{ selectedCandidateData?.targetRateTo }} {{ getCurrency(selectedCandidateData?.country) }} / {{ getPayType(selectedCandidateData?.payType) }}
                    </ng-container>
                    <ng-template #noRateDetailHeader>Not available</ng-template>
                  </div>
                </div>
                <div class="jc-v3-dh-tags">
                  <div class="jc-v3-dh-tag" *ngIf="selectedCandidateData?.workMode">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    {{ selectedCandidateData?.workMode }}
                  </div>
                  <div class="jc-v3-dh-tag" *ngIf="selectedCandidateData?.workAuthorization">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    {{ selectedCandidateData?.workAuthorization }}
                  </div>
                  <div class="jc-v3-dh-tag" *ngIf="selectedCandidateData?.securityClearance">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    Security Clearance
                  </div>
                </div>
              </div>
            </div>

            <div class="entity-details-header">
              <app-candidate-portfolio [candidateDetails]="selectedCandidateData" [pageName]="candidateDetailsTabName"
                [candidatePortfolio]="candidatePortfolioModule" [designVersion]="designVersion"
                (resetfilters)="filterReset($event)"
                (removeJob)="removeJobId($event)"></app-candidate-portfolio>
            </div>
            <div class="entity-details-body" [class.jc-v3-entity-details-body]="designVersion === 'v3'">

              <!-- Kept mounted on every tab (hidden when not the Profile tab)
                   so `#profileSummaryRef` is always available. The detail-header
                   Edit / Available toggle / Invite / Upload Resume actions delegate
                   to this component (editSelectedCandidate → profileSummaryRef.triggerEdit,
                   etc.); when it was `*ngIf`'d to only the Profile tab, the ref was
                   undefined on Applied / Marketplace / Resume Requests / Likes /
                   Event Logs, so the optional-chained calls were silent no-ops and
                   the buttons appeared unclickable. Mirrors the Job page, where the
                   always-present left panel (jobsRef) backs every header action. -->
              <app-candidate-profile-summary #profileSummaryRef [hidden]="candidateDetailsTabName !== 'profileSummary'"
                [candidateDetails]="selectedCandidateData" [passValues]="(response | async)"
                [designVersion]="designVersion" [jobId]="jobIdgetfromIntraction"
                (candidateListing)="onStatuChange($event)" (candidateFilterFromComponent)="onStatusChangeEvent($event)"
                (candidateReloadFromComponent)="reloadFilter($event)"></app-candidate-profile-summary>
              <app-candidate-job-invite *ngIf="candidateDetailsTabName === 'cInvited'"
                [candidateDetails]="selectedCandidateData" [clickedJobIdIntraction]="jobIdgetfromIntraction"
                [designVersion]="designVersion"
                (parentValueChange)="updatetocandidateActivity($event)"></app-candidate-job-invite>
              <app-candidate-requests-received *ngIf="candidateDetailsTabName === 'candidate-requests-received'"
                [candidateDetails]="selectedCandidateData"
                [designVersion]="designVersion"></app-candidate-requests-received>
              <app-job-applied-candidates *ngIf="candidateDetailsTabName === 'jobsApplied'"
                [candidateDetails]="selectedCandidateData" [clickedJobIdIntraction]="jobIdgetfromIntraction"
                [pageFrom]="'jobsApplied'" [designVersion]="designVersion"
                (parentValueChange)="updatetocandidateActivity($event)"></app-job-applied-candidates>
              <app-job-applied-candidates *ngIf="candidateDetailsTabName === 'suggestedJobs'"
                [candidateDetails]="selectedCandidateData" [clickedJobIdIntraction]="jobIdgetfromIntraction"
                [pageFrom]="'suggestedJobs'" [designVersion]="designVersion"
                (parentValueChange)="updatetocandidateActivity($event)"></app-job-applied-candidates>
              <app-candidate-viewed-by *ngIf="candidateDetailsTabName === 'views'"
                [candidateDetails]="selectedCandidateData"
                [designVersion]="designVersion"></app-candidate-viewed-by>
              <app-job-publishto [Event]="event" *ngIf="candidateDetailsTabName === 'candidate-activity'"
                [candidateDetails]="selectedCandidateData"></app-job-publishto>
              <app-candidate-like *ngIf="candidateDetailsTabName === 'Clike-like'"
                [candidateDetails]="selectedCandidateData"
                [designVersion]="designVersion"></app-candidate-like>

            </div>
          </ng-container>
        </div>
        <ng-template #emptyMessage>
          <div class="entity-details" [class.jc-v3-entity-details]="designVersion === 'v3'" *ngIf="!loadAPIcall">
            <div class="jc-v3-detail-empty" *ngIf="designVersion === 'v3'">
              <ng-icon name="customEmpty"></ng-icon>
              <p>There's nothing to show here.</p>
            </div>
            <div class="nothing-to-show-svg" *ngIf="designVersion !== 'v3'">
              <ng-icon name="customEmpty"></ng-icon>
              <div>There's nothing to show here.</div>
            </div>
          </div>
        </ng-template>

        <!-- <div>
            <app-job-activity-widget [candidateDetails]="selectedCandidateData" [TabName]="candidateDetailsTabName"
              [JobAcvityData]="JobAcvityDatas"></app-job-activity-widget>
          </div> -->
        <!-- <div class="widget-flex-item">
          <div [class.suggestionStick]="suggestionStick" #suggestionSticky>
            <app-common-widget *ngIf="userType!='FREELANCE_RECRUITER' && userType!='MANAGEMENT_TALENT_ACQUISITION'"
              [page]="'GIG_CANDIDTAE_LIST'" [showflag]="jobfilter" [showsuggJobsData]="showsuggJobsData"
              [inputData]="'GIG_CANDIDTAE_LIST'"></app-common-widget>
            <app-common-widget *ngIf="userType=='FREELANCE_RECRUITER'|| userType=='MANAGEMENT_TALENT_ACQUISITION'"
              [page]="'GIG_CANDIDTAE_LIST_BOTH'" [showflag]="jobfilter" [showsuggJobsData]="showsuggJobsData"
              [inputData]="'GIG_CANDIDTAE_LIST_BOTH'"></app-common-widget>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div class="chatPopup">
    <button (click)="chatbottom()" class="btn btn-info btn-circle" type="button"> <ng-icon name="tablerMessage"></ng-icon> Chat
      <span class="badge noti-badge noti-chat-icon" *ngIf="totalmsgcounts>0"> {{totalmsgcounts}}</span></button>
    <app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" style="z-index: -1;"
      [messageDataPass]="messageData"> </app-message-widget>
  </div>
</ng-container>

<ng-container *ngIf="screenName == 'job-listing'">
  <div class="row mr-0">
    <div class="col-sm-8 pad-lt-rt-0">
      <div class="xs-heading-flex-parent">
        <div class="xs-heading-entity">My Candidates</div>
        <div class="xs-heading-payrate">Pay Rate</div>
        <div class="xs-heading-paytype">Type</div>
      </div>
      <div class="xs-body-container" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="200"
        (scrolled)="onScrollDown()" [scrollWindow]="false" [alwaysCallback]="true">
        <app-candidates-page (candidateReloadFromComponent)="reloadFilter($event)" [viewSize]="'extra-small'"
          [candidatesFoundStatus]="candidateFoundStatus" [passValues]="(response | async)" [jobData]="jobDataToBeSent"
          [removeSelected]="removeSelected" [fromApply]="true" [removeTag]="removeTagvalues"
          (candidateReload)="reloadFilter($event)" (suggjob)="getsuggjob($event)"
          (candidateFilterFromComponent)="onStatusChangeEvent($event)" (selectedCandidate)="getchildData($event)"
          [responseReceived]="apiCompleted"></app-candidates-page>
      </div>
      <div class="xs-footer-container"></div>
    </div>
    <div class="col-sm-4 pad-lt-0 pad-rt-0">
      <div class="hpanel mr-bt-0" data-gs-cards="native">
        <div class="hpanel-heading xs-heading-flex-entity-detail">
          <div>Job Details</div>
          <button><span class="modalai-close" aria-hidden="true"
              (click)="closeCandidateSupplyModal()">&times;</span></button>
        </div>
        <app-job-submit-skillfilter [focus]="'job'" [jobData]="jobData" [feaJ]="feaJ"
          [dataPasstoSkillwidgets]="dataPasstoSkillwidgets" (emitRemoveTag)="removeUserfromTag($event)">
        </app-job-submit-skillfilter>
      </div>
    </div>
  </div>
</ng-container>